import { PDFDocument } from "pdf-lib";

/** The PDF already loaded by the preview, including the OCR/search preview path. */
export type PreviewPdfDocument = {
  url: string;
  numPages: number;
  getData: () => Promise<Uint8Array>;
};

export function singlePageFilename(name: string, pageNumber: number): string {
  const stem = name.replace(/\.pdf$/i, "").replace(/[<>:"/\\|?*\x00-\x1f]/g, "_").trim();
  return `${stem || "document"}-page-${pageNumber}.pdf`;
}

/** Copy the original page rather than rasterizing or fitting it to another paper size. */
export async function extractPdfPage(bytes: Uint8Array, pageNumber: number): Promise<Uint8Array> {
  const source = await PDFDocument.load(bytes);
  if (!Number.isInteger(pageNumber) || pageNumber < 1 || pageNumber > source.getPageCount()) {
    throw new Error("Choose a valid page number.");
  }
  const output = await PDFDocument.create();
  const [page] = await output.copyPages(source, [pageNumber - 1]);
  output.addPage(page);
  return output.save();
}

export function savePdfDownload(bytes: Uint8Array, filename: string): void {
  const url = URL.createObjectURL(new Blob([new Uint8Array(bytes)], { type: "application/pdf" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
    // Give the browser time to consume the download before releasing its bytes.
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
  }
}
